const eu = {
  common: {
    actions: {
      close: 'Itxi',
      accept: 'Onartu',
      back: 'Atzera',
      continue: 'Jarraitu',
    },
    errors: {
      title: 'Errorea',
      unknown: 'Errore ezezaguna.',
    },
    fields: {
      email: 'Posta elektronikoa',
      firstName: 'Izena',
      lastName: 'Abizenak',
      country: 'Herrialdea',
      city: 'Hiria',
      postalCode: 'Posta kodea',
      password: 'Pasahitza',
      confirmPassword: 'Errepikatu pasahitza',
      companyName: 'Enpresaren izena',
      userType: 'Erabiltzaile mota',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
    },
    userTypes: {
      person: 'Autonomoa',
      company: 'Enpresa',
    },
  },

  paymentCancelled: {
    title: 'Ordainketa bertan behera utzita',
    description:
      'Ordainketa prozesua bertan behera utzi da. Akats bat izan bada, berriro saia zaitezke.',
  },

  paymentSuccess: {
    title: 'Ordainketa arrakastaz egin da!',
    descriptionDemo:
      'Orain <link>sartu</link> zaitezke eta gure plataformaren abantaila guztiez gozatu.',
    descriptionStandard:
      'Mezu elektroniko bat bidali dizugu zure harpidetzaren xehetasunekin. Mesedez, egiaztatu sarrera-ontzia eta jarraitu argibideak prozesua osatzeko.',
  },

  registration: {
    title: 'Erregistroa hasi',
    titleDemo: 'Demo erregistroa hasi',
    complete: 'Osatu',
    stepsCount: '3 urrats',
    toCreateAccount: 'zure kontua sortzeko',
    planFallback: 'Plana',
    planSelection: 'Planaren hautaketa',
    expensesTotalUsers: 'Guztira: {{total}} erabiltzaile Billivo Expenses-en ({{base}} planean sartuta)',
    inviteApplied:
      'Zure kudeaketa-bulegoaren gonbidapena aplikatuta: 50 € deskontu Business Advance + Acceso al Contable urteko planean.',
    inviteRequiresPlan:
      'Zure kudeaketa-bulegoak 50 €-ko deskontuarekin gonbidatzen zaitu. Deskontua Business Advance + Acceso al Contable planari aplikatzen zaio, urteko fakturazioarekin.',

    steps: {
      account: 'Kontua',
      userData: 'Erabiltzailearen datuak',
      addressAndConfirmation: 'Helbidea eta berrespena',
      planAndAccount: 'Plana eta kontua',
    },

    userTypes: {
      person: 'Autonomoa',
      company: 'Enpresa',
      agent: 'Kudeatzailea',
    },

    fields: {
      agentName: 'Kudeatzailearen izena',
      agentDocument: 'NIF/CIF/NIE',
      agentVatId: 'VAT ID',
      agentPhoneNumber: 'Telefono zenbakia',
      agentWebsite: 'Webgunea',
      referralOptIn: 'Kudeatzailearen erreferentzia-sisteman parte hartu nahi duzu?',
      subscriptionPlan: 'Harpidetza plana',
      billingPeriod: 'Fakturazio aldia',
      expensesPacks: 'Billivo Expenses pakete gehigarriak (10 erabiltzaile bakoitzak)',
      userType: 'Erabiltzaile mota',
      companyName: 'Enpresaren izena',
      firstName: 'Izena',
      lastName: 'Abizenak',
      email: 'Posta elektronikoa',
      password: 'Pasahitza',
      confirmPassword: 'Errepikatu pasahitza',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      vatId: 'VAT ID',
      phoneNumber: 'Telefono zenbakia',
      taxType: 'Zerga mota',
      addressLine1: 'Helbide lerroa 1',
      addressLine2: 'Helbide lerroa 2',
      postalCode: 'Posta kodea',
      city: 'Hiria',
      country: 'Herrialdea',
      discountCode: 'Deskontu kodea',
      referredByCode: 'Erreferentzia kodea',
    },

    billing: {
      monthly: 'Hilekoa',
      yearly: 'Urtekoa',
      popular: 'Ezaguna',
      save17: '%17 aurreztu',
      monthShort: 'hil',
      yearShort: 'urte',
    },

    taxTypes: {
      peninsula: '01 - Penintsula',
      ceutaMelilla: '02 - Ceuta eta Melilla',
      canaryIslands: '03 - Kanariar Uharteak',
      other: '05 - Beste batzuk',
    },

    api: {
      devOnly: '⚙️ [GARATZAILEENTZAT BAKARRIK]',
      useApi: 'Billivoren APIa erabili nahi dut',
      numberingManagement: 'Zenbaketaren kudeaketa',
      selectOption: 'Hautatu aukera bat',
      erpOption: 'Nik neuk kontrolatu nahi dut fakturen numerazioa',
      noErpOption: 'Billivok numerazioa kudeatzea nahi dut',
    },

    accessibility: {
      showPassword: 'Pasahitza erakutsi',
      hidePassword: 'Pasahitza ezkutatu',
      showConfirmPassword: 'Berrespena erakutsi',
      hideConfirmPassword: 'Berrespena ezkutatu',
    },

    actions: {
      continue: 'Jarraitu',
      back: 'Atzera',
      sending: 'Bidaltzen...',
      finishRegistration: 'Erregistroa amaitu',
      close: 'Itxi',
      accept: 'Onartu',
    },

    status: {
      sendingInfo: 'Informazioa bidaltzen...',
    },

    errors: {
      title: 'Errorea',
      unknown: 'Errore ezezaguna.',
      submitUnknown: 'Errore ezezaguna formularioa bidaltzean',
      stripeLoadFailed: 'Ezin izan da Stripe kargatu.',
      noSession: 'Ez dago birbideratzeko saiorik',
    },

    validation: {
      invalidWebsite: 'Webgunea ez da baliozkoa',
      validOption: 'Hautatu baliozko aukera bat',
      apiUsageTypeRequired: 'Hautatu nola kudeatu numerazioa',
      emailRequired: 'Posta elektronikoa derrigorrezkoa da',
      invalidEmail: 'Posta elektroniko baliogabea',
      companyNameRequired: 'Enpresaren izena derrigorrezkoa da',
      firstNameRequired: 'Izena derrigorrezkoa da',
      lastNameRequired: 'Abizenak derrigorrezkoak dira',
      nationalIdRequired: 'NIF/NIE/CIF derrigorrezkoa da',
      invalidDocument: 'Dokumentu baliogabea',
      invalidCif: 'CIF baliogabea',
      invalidNifNie: 'NIF/NIE baliogabea',
      taxTypeRequired: 'Zerga mota derrigorrezkoa da',
      phoneRequired: 'Telefono zenbakia derrigorrezkoa da',
      addressRequired: 'Helbidea derrigorrezkoa da',
      postalCodeRequired: 'Posta kodea derrigorrezkoa da',
      cityRequired: 'Hiria derrigorrezkoa da',
      countryRequired: 'Herrialdea derrigorrezkoa da',
      billingPeriodRequired: 'Fakturazio aldia derrigorrezkoa da',
      passwordRequired: 'Pasahitza derrigorrezkoa da',
      passwordMin: 'Gutxienez 8 karaktere',
      confirmPasswordRequired: 'Errepikatu pasahitza',
      passwordsDoNotMatch: 'Pasahitzak ez datoz bat',
      maxLength: 'Gehienez {{max}} karaktere',
      maxValue: 'Gehienez {{max}}',
    },

    terms: {
      acceptPrefix: 'Onartzen ditut',
      linkText: 'baldintzak eta terminoak',
      title: 'Terminoak eta Baldintzak',
      sections: {
        general: {
          title: '1. Informazio orokorra eta onarpena',
          body: 'Termino eta baldintza hauek Billivorako sarbidea eta erabilera arautzen dituzte.',
        },
        definitions: {
          title: '2. Definizioak',
          body: 'Erabiltzailea: Billivo erabiltzen duen pertsona fisikoa. Zerbitzuak: Billivoren bidez eskaintzen diren funtzionalitateak. Edukia: Billivon eskuragarri dagoen edozein informazio edo material.',
        },
        scope: {
          title: '3. Xedea eta irismena',
          body: 'Billivok erabiltzaileei enpresak eskaintzen dituen zerbitzuetara sartzeko aukera ematen die.',
        },
        access: {
          title: '4. Erregistroa eta sarbidea',
          body: 'Beharrezkoa izan daiteke erregistratzea eta kontu bat sortzea, datu egiazko eta eguneratuekin.',
        },
        usage: {
          title: '5. Billivoren erabilera',
          body: 'Erabiltzaileak Billivo legez eta fede onez erabiltzeko konpromisoa hartzen du.',
        },
        privacy: {
          title: '6. Pribatutasuna eta datuen babesa',
          body: 'Datu pertsonalen bilketa eta tratamendua indarrean dagoen araudiaren arabera arautzen dira.',
        },
        communications: {
          title: '7. Komunikazio komertzialak eta buletinak',
          body: 'Termino hauek onartzean, erabiltzaileak Billivorekin lotutako zenbait komunikazio baimentzen ditu.',
        },
        intellectualProperty: {
          title: '8. Jabetza intelektuala eta industriala',
          body: 'Billivoren eta haren edukien gaineko eskubide guztiak enpresarenak edo baimendutako hirugarrenenak dira.',
        },
        liability: {
          title: '9. Bermeen eta erantzukizunaren salbuespena',
          body: 'Enpresak ez du bermatzen Billivoren etengabeko erabilgarritasuna kasu guztietan.',
        },
        thirdPartyLinks: {
          title: '10. Hirugarrenen guneetarako estekak',
          body: 'Billivok hirugarrenen guneetarako estekak izan ditzake, eta ez du haien edukiaren erantzukizunik hartzen.',
        },
        modifications: {
          title: '11. Terminoen aldaketa',
          body: 'Enpresak termino hauek aldatu ahal izango ditu beharrezkotzat jotzen duenean.',
        },
        termination: {
          title: '12. Amaiera',
          body: 'Enpresak sarbidea eten edo baliogabetu ahal izango du ez-betetze edo erabilera iruzurtia gertatuz gero.',
        },
        jurisdiction: {
          title: '13. Aplikatu beharreko legea eta jurisdikzioa',
          body: 'Termino hauek Espainiako legediaren mende daude.',
        },
        contact: {
          title: '14. Harremana',
          body: 'Edozein zalantza izanez gero, erabiltzaileak enpresarekin harremanetan jar daiteke posta elektroniko bidez.',
        },
      },
    },
  },

  registrationSuccess: {
    title: 'Erregistroa arrakastaz egin da!',
    descriptionDemo:
      'Orain <link>sartu</link> zaitezke eta gure plataformaren abantaila guztiez gozatu.',
    descriptionStandard:
      'Mezu elektroniko bat bidali dizugu zure erregistroaren xehetasunekin. Mesedez, egiaztatu sarrera-ontzia eta jarraitu argibideak prozesua osatzeko.',

    apiCredentials: {
      title: 'API kredentzialak - GARRANTZITSUA!',
      warning:
        'Pasahitz hau <strong>EZ da gorde</strong> eta behin bakarrik erakutsiko da. Gorde leku seguruan orri honetatik irten aurretik.',
      emailLabel: 'Posta elektronikoa:',
      passwordLabel: 'Pasahitza:',
    },

    snackbar: {
      copied: '{{field}} arbelean kopiatu da',
      email: 'Posta elektronikoa',
      password: 'Pasahitza',
    },
  },

  simpleForm: {
    title: 'Erregistro azkarra',
    subtitle: 'Bete formularioa eta amaieran zure QRa erakutsiko dizugu.',
    optional: 'Aukerakoa',
    fields: {
      country: 'Herrialdea',
      userType: 'Erabiltzaile mota',
      firstName: 'Izena',
      lastName: 'Abizenak',
      companyName: 'Enpresaren izena',
      email: 'Posta elektronikoa',
      vatId: 'VAT ID',
      cif: 'CIF',
      nifNie: 'NIF/NIE',
      taxId: 'Identifikazio fiskaleko zenbakia',
      taxIdOptional: 'Identifikazio fiskaleko zenbakia (aukerakoa)',
    },
    userTypes: {
      person: 'Autonomoa',
      company: 'Enpresa',
    },
    helpers: {
      companyCif: 'Sartu enpresaren CIFa',
      personNifNie: 'Sartu zure NIF edo NIE',
      euRequired: 'Eremu hau derrigorrezkoa da EBko bezeroentzat',
      outsideEuOptional: 'Bete dezakezu identifikazio fiskala baduzu',
    },
    validation: {
      countryRequired: 'Herrialdea derrigorrezkoa da',
      userTypeRequired: 'Erabiltzaile mota derrigorrezkoa da',
      emailRequired: 'Posta elektronikoa derrigorrezkoa da',
      invalidEmail: 'Posta elektroniko baliogabea',
      companyNameRequired: 'Enpresaren izena derrigorrezkoa da',
      firstNameRequired: 'Izena derrigorrezkoa da',
      lastNameRequired: 'Abizenak derrigorrezkoak dira',
      nationalIdRequiredSpain: 'NIF/NIE/CIF derrigorrezkoa da',
      invalidDocument: 'Dokumentu baliogabea',
      invalidCif: 'CIF baliogabea',
      invalidNifNie: 'NIF/NIE baliogabea',
      taxIdRequired: 'Identifikazio fiskaleko zenbakia derrigorrezkoa da',
    },
    actions: {
      register: 'Erregistratu',
      registering: 'Erregistratzen...',
      close: 'Itxi',
      accept: 'Onartu',
    },
    status: {
      sending: 'Informazioa bidaltzen...',
    },
    errors: {
      title: 'Errorea',
      unknownError: 'Errore ezezaguna.',
      submitError: 'Errore ezezaguna formularioa bidaltzean',
    },
    terms: {
      acceptPrefix: 'Onartzen ditut',
      linkText: 'terminoak eta baldintzak',
      title: 'Terminoak eta Baldintzak',
      sections: {
        general: {
          title: '1. Informazio orokorra eta onarpena',
          body: 'Termino eta baldintza hauek ("Terminoak") Code10 IT Consultants S.L.k garatutako mugikor eta/edo web aplikazioaren (aurrerantzean Billivo) sarbidea eta erabilera arautzen dituzte. Terminoekin ados ez bazaude, ez erabili Billivo.',
        },
        definitions: {
          title: '2. Definizioak',
          body: 'Erabiltzailea: Termino hauek onartu ondoren, Billivo erabiltzen duen pertsona fisikoa, bere izenean edo hirugarren baten ordez jarduten duen kontuan hartu gabe.',
        },
        scope: {
          title: '3. Xedea eta irismena',
          body: 'Billivok erabiltzaileei enpresak eskaintzen dituen zerbitzuetara sartzeko aukera ematen die. Billivoren erabilera pertsonala eta ez-komertziala da.',
        },
        access: {
          title: '4. Erregistroa eta sarbidea',
          body: 'Zenbait zerbitzu erabiltzeko beharrezkoa izan daiteke erregistratzea eta kontu bat sortzea, datu egiazko eta eguneratuak emanez. Erabiltzailea da bere kredentzialak zaintzearen arduraduna.',
        },
        usage: {
          title: '5. Billivoren erabilera',
          body: 'Erabiltzaileak Billivo modu legezkoan, fede onez eta ordenamendu juridikoa urratu gabe erabiltzeko konpromisoa hartzen du.',
        },
        privacy: {
          title: '6. Pribatutasuna eta datuen babesa',
          body: 'Datu pertsonalen bilketa eta tratamendua Pribatutasun Politikaren eta aplikatu beharreko indarreko araudiaren arabera arautzen dira.',
        },
        communications: {
          title: '7. Komunikazio komertzialak eta buletinak',
          body: 'Termino hauek onartzean eta Billivon alta ematean, erabiltzaileak berariaz baimentzen dio enpresari bere helbide elektronikoa eta beste harremanetarako datu batzuk erabiltzea komunikazioak bidaltzeko.',
        },
        intellectualProperty: {
          title: '8. Jabetza intelektuala eta industriala',
          body: 'Billivoren, haren iturburu-kodeen, diseinuaren, edukien, logotipoen eta marken gaineko jabetza intelektual eta industrialeko eskubide guztiak enpresarenak edo erabilera baimendu duten hirugarrenenak dira.',
        },
        liability: {
          title: '9. Bermeen eta erantzukizunaren salbuespena',
          body: 'Enpresak ez du bermatzen Billivoren erabilgarritasuna, jarraitutasuna edo hutsegiterik eza, eta legez baimentzen den neurrian erantzukizunetik salbuetsita geratzen da.',
        },
        thirdPartyLinks: {
          title: '10. Hirugarrenen guneetarako estekak',
          body: 'Billivok hirugarrenen webgune edo edukietarako estekak izan ditzake. Enpresak ez ditu gune horiek kontrolatzen eta ez da haien edukien erantzule.',
        },
        modifications: {
          title: '11. Terminoen aldaketa',
          body: 'Enpresak Termino hauek aldatu ahal izango ditu beharrezkotzat jotzen duenean. Aldaketak argitaratzen diren unetik aurrera jarriko dira indarrean.',
        },
        termination: {
          title: '12. Amaiera',
          body: 'Enpresak erabiltzailearen sarbidea eten edo baliogabetu ahal izango du ez-betetzeak, erabilera iruzurtia edo legearen aurkakoa detektatzen dituenean.',
        },
        jurisdiction: {
          title: '13. Aplikatu beharreko legea eta jurisdikzioa',
          body: 'Termino hauek Espainiako legediaren arabera arautzen dira. Gatazkak ebazteko, alderdiak eskumena duten epaitegi eta auzitegien mende jartzen dira.',
        },
        contact: {
          title: '14. Harremana',
          body: 'Edozein zalantza edo kontsulta egiteko, erabiltzaileak enpresarekin harremanetan jar daiteke support@billivo.com helbidera mezu elektroniko bat bidaliz.',
        },
      },
    },
  },

  simpleFormSuccess: {
    notFound: {
      title: 'Ez da erregistroa aurkitu',
      description: 'Ez dugu nahikoa informazio QRa erakusteko.',
      backButton: 'Formulariora itzuli',
    },
    success: {
      title: 'Erregistroa arrakastaz egin da!',
      description:
        'Zure erabiltzailea ondo sortu da. Gorde QR hau eta erakutsi gidariari zure faktura egin ahal izan dezan.',
    },
    temporaryPassword: {
      title: 'Aldi baterako pasahitza',
      description: 'Pasahitz hau automatikoki sortu da eta lehen saio-hasieran aldatu beharko da.',
      emailLabel: 'Posta elektronikoa:',
      passwordLabel: 'Aldi baterako pasahitza:',
    },
    snackbar: {
      copied: '{{field}} arbelean kopiatu da',
      email: 'Posta elektronikoa',
      temporaryPassword: 'Aldi baterako pasahitza',
    },
  },
};

export default eu;
